import { inject as service } from '@ember/service';
import { resolve } from 'rsvp';
import Base from 'ember-simple-auth/authenticators/base';
import { setAccessCookie, getAccessCookie } from 'cio/utils/auth-cookies';

import { TwoFactorAuthRequiredError } from 'cio/authenticators/login-2fa';
import ApiService from 'cio/services/api';
import { LoginSuccessResponse, LoginTwoFactorAuthRequiredResponse } from 'cio/authenticators/login-email-password';
import { LoginMeta } from 'cio/pods/login/controller';

export default class LoginGoogleOneClickChooseUserFinishAuthenticator extends Base {
  @service api!: ApiService;

  restore(_data: unknown) {
    return resolve({
      accessToken: getAccessCookie() as string,
    });
  }

  authenticate({ userID, chooseUserJWTToken, meta }: { userID: string; chooseUserJWTToken: string; meta: LoginMeta }) {
    return this.api
      .post('login_google_one_click_choose_user_finish', {
        data: { user_id: userID, choose_user_jwt_token: chooseUserJWTToken, ga_client_id: meta.ga_client_id },
        ignoreErrors: true,
        pathScope: 'global',
      })
      .then((res: LoginSuccessResponse | LoginTwoFactorAuthRequiredResponse) => {
        if ('2fa_login_token' in res) {
          throw new TwoFactorAuthRequiredError(res['2fa_login_token']);
        }

        setAccessCookie(res.access_token);

        return { accessToken: res.access_token };
      });
  }
}
